module.exports = __webpack_public_path__ + "img/cb-statement.c2f9c94.png";